export default "__VITE_ASSET__oIgjfMGb__"